const unNestUntypedUser = (data: any) => data.user;
const unNestUntypedUsers = (users: any[]) => users.map(unNestUntypedUser);
const nestUserIdIris = (users: IIdIri[]) => users.map((m) => ({ user: m.idIri }));

export { nestUserIdIris, unNestUntypedUser, unNestUntypedUsers };
